import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import Waveform from './Audio/WaveForm';
import { Slider } from '@mui/material';

function valuetext(value) {
    return `${value}°C`;
}

function AutoPanner() {
    const [IsHide, setIsHide] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [outputFileName, setOutputFileName] = useState(false);
    const [value, setValue] = useState([20, 30]);
    const [range, setRange] = useState(0);
    const [selectedTrack, setSelectedTrack] = useState();
    const [outPutAudio, setoutPutAudio] = useState();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const navigate = useNavigate();
    const handleAudio = (id) => {
        setIsHide(id);
    };
    const handleReverse = (id) => {
        setIsHide(id);
        if (id === 2) {
            setTimeout(function () {
                setIsHide(3);
            }, 5000);
        }
    };

    const handleFileChange = (event) => {
        setIsHide(1);
        setSelectedFile(event.target.files[0]);

        console.log("mp3:", selectedFile)

        localStorage.setItem("audurl", URL.createObjectURL(event.target.files[0]))
        setSelectedTrack(URL.createObjectURL(event.target.files[0]))
    };

    const handleUpload = async () => {
        setIsHide(2);
        const formData = new FormData();
        formData.append('audioFile', selectedFile);
        formData.append('arg1', range);
        try {
            const response = await fetch('https://audio.aicte-india.org/AutoPanner', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const modifiedAudioBlob = await response.blob();
                const url = URL.createObjectURL(modifiedAudioBlob);
                localStorage.setItem('audio',url);
                setAudioUrl(url);
                const fileName = `${selectedFile?.name}-Autopanned-${Date.now()}.mp3`;
                const audioURL = url+'/'+fileName;
                setoutPutAudio(url);
                setOutputFileName(fileName);
                setIsHide(3);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            setLoading(false);
        }
    };

    return (
        <>
            <div className="banner-allpage-sec">
                <ul className="breadcrumb">
                    <li><Link to="/audio/">Home</Link></li>
                    <li>Voice</li>
                    <li>Auto Panner</li>
                </ul>
                <div className="banner-content-sec text-center" style={{padding:"0px 0 50px"}}>
                    <h1 className="first-head">Auto Panner</h1>
                   
                </div>
            </div>
            {(IsHide == 0) ? (
                <>
                 <h3 className="second-head" style={{ textAlign: "center", marginTop: -120, position:"relative", zIndex:"0"}}>Manipulate audio files to automatically control panning of audio in a stereo image, left to right or in a circular fashion to create unique listening experiences. </h3>

<br />
                    <section style={{ textAlign: "center", position: "relative" }}>
                        <div className="page-container">
                            <div style={{ border: "#ccc 2px dotted", borderRadius: 10, background: "#fff", padding: 50, width: "100%", margin: "auto" }}>
                                <div className="chakra-heading" style={{ fontSize: 20, fontWeight: "bold" }}>Drag and drop a file from which you want to edit</div>
                                <p className="chakra-text">or</p>
                                <div className='upload-btn-wrapper'>
                                    <input type="file" style={{ fontSize: 26, borderRadius: 10, padding: "15px 30px" }} onChange={handleFileChange} />
                                    <button className="button orange opnoriginalResultDiv" ><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{ width: 30, height: 30, position: "relative", top: 0 }} xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"></path><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 255.79l-64-64-64 64m64 192.42V207.79"></path></svg>
                                        Browse Computer</button>
                                </div>
                                <div className="txt-eg">Supported file format: WAV Max file size 50MB.</div>
                            </div>
                        </div>
                    </section>
                </>
            ) : ''}

            {(IsHide == 1) ? (
                <>
                    <section style={{ textAlign: "center", marginTop: -120, position: "relative", marginBottom: 50 }}>
                        <div className='container'>
                            <div className="stepThree" style={{ border: "2px dotted rgb(204, 204, 204)", borderRadius: 10, background: "rgb(255, 255, 255)", padding: 50, width: "100%", margin: "auto" }}>
                                <div style={{ textAlign: "left" }}>
                                    <div className='upload-btn-wrapper'>
                                    <input type="file" style={{ fontSize: 26, borderRadius: 10, padding: "15px 30px" }} onChange={handleFileChange} />
                                    {/* <button className="button orange opnoriginalResultDiv" ><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{ width: 30, height: 30, position: "relative", top: 0 }} xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"></path><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 255.79l-64-64-64 64m64 192.42V207.79"></path></svg>
                                        Browse Computer</button> */}
                                    </div>
                                    <h2 style={{ marginTop: 5, fontSize: 14 }}>Input File Name : {selectedFile?.name}</h2>
                                </div>
                                <Waveform type={1} />
                                <br /><br />
                                <br />
                                <br />
                                <input type="range" min="0" max="5" step="0.01" className='sliderGreen' style={{ minWidth: "100%" }} value={range} onChange={(e) => setRange(e.target.value)} />
                               <div className='d-flex justify-content-center align-items-center panamt'>
                               <div className='text-start' style={{marginRight:8}}>
                                <p>Pan Amount </p>
                                </div>
                                {range} <br />
                               </div>
                                
                                <div className="waveBox"> 

                                </div>
                                <div style={{ textAlign: "right" }}>
                                    <button type="file" onClick={handleUpload} className="button orange opnoriginalResultDiv clickForFour" style={{ padding: "10px 15px 10px", display: "inline-flex", gap: 6 }}>
                                        <ArrowRight size={20} /> Submit
                                        {/* <svg viewBox="0 0 24 24" style={{width:20}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.3153 16.6681C15.9247 17.0587 15.9247 17.6918 16.3153 18.0824C16.7058 18.4729 17.339 18.4729 17.7295 18.0824L22.3951 13.4168C23.1761 12.6357 23.1761 11.3694 22.3951 10.5883L17.7266 5.9199C17.3361 5.52938 16.703 5.52938 16.3124 5.91991C15.9219 6.31043 15.9219 6.9436 16.3124 7.33412L19.9785 11.0002L2 11.0002C1.44772 11.0002 1 11.4479 1 12.0002C1 12.5524 1.44772 13.0002 2 13.0002L19.9832 13.0002L16.3153 16.6681Z" fill="#fff"></path> </g></svg> */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : ''}


            {(IsHide == 2) ? (
                <>
                    <div className='container' style={{ textAlign: "center", marginTop: -120, position: "relative", marginBottom: 50 }}>
                        <div className="stepFour clickForFive" style={{ borderRadius: 10, background: "rgb(190, 227, 248)", padding: 50, width: "100%", margin: "auto" }}>
                            <p className="chakra-text">
                                <img src="./assets/images/loader_bagic.gif" alt="" style={{ width: 65 }} /></p>
                            <div className="chakra-heading" style={{ fontSize: 20, fontWeight: "bold" }}>Your audio file is being processed...</div>
                            <p className="chakra-text">This may take some time. Stay on this page or come back later to get the result.</p>
                        </div>
                    </div>
                </>
            ) : ''}
            {(IsHide == 3) ? (
                <>
                                        <div className='container' style={{ textAlign: "center", marginTop: -120, position: "relative", marginBottom: 50 }}>
                            <div className='row'>
                                <div className='col-lg-12'>
                                <div className='text-end mb-3'>
                                <button type="file" onClick={() => navigate(-0)} className="button green clickForOne">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292"></path></svg>
                                Edit another file
                            </button>
                                </div>
                                </div>
                            </div>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                                <div style={{ border: "#ccc 2px dotted", borderRadius: 10, background: "#fff", padding: "20px 20px 84px", width: "100%", margin: "auto" }}>
                                    <div className="waveBox text-start">
                                        <h3>Input Audio File</h3>
                                        <Waveform type={1} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                                
                                <div style={{ border: "#ccc 2px dotted", borderRadius: 10, background: "#fff", padding: "20px 20px 84px", width: "100%", margin: "auto" }}>
                                    <div className="waveBox text-start">
                                        <h3>Output Audio File </h3>
                                        {/* <Waveform url={outputFileName ? audioUrl : ""} /> */}
                                        {localStorage.getItem('audio')?(
                                            // <Waveform url={localStorage.getItem('audio')} />
                                            <Waveform type={2} />
                                        ):''}

                                        {/* <audio controls>
                                        <source src={localStorage.getItem('audio')} type="audio/ogg"/>
                                        <source src={localStorage.getItem('audio')} type="audio/mpeg"/>
                                        Your browser does not support the audio element.
                                        </audio> */}
                                        
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="stepFive mt-3">
                            <div style={{ borderRadius: 10, background: "#c6f6d5", padding: "10px 20px 20px", width: "100%", margin: "auto" }}>
                                <p className="chakra-text">
                                    <img src="./assets/images/icon-success.png" alt="" style={{ width: 65 }} /></p>
                                <div className="chakra-heading" style={{ fontSize: 20, fontWeight: "bold" }}>Your audio file was successfully processed!</div>
                            </div>
                            <br /><br />

                            <div className='mt-4'>
                                <a href={audioUrl} download={outputFileName} className="button orange opnoriginalResultDiv" style={{ fontSize: 24, borderRadius: 10, padding: "15px 30px 15px" }}>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{ width: 30, height: 30, position: "relative", top: 0 }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M12 12V19M12 19L9.75 16.6667M12 19L14.25 16.6667M6.6 17.8333C4.61178 17.8333 3 16.1917 3 14.1667C3 12.498 4.09438 11.0897 5.59198 10.6457C5.65562 10.6268 5.7 10.5675 5.7 10.5C5.7 7.46243 8.11766 5 11.1 5C14.0823 5 16.5 7.46243 16.5 10.5C16.5 10.5582 16.5536 10.6014 16.6094 10.5887C16.8638 10.5306 17.1284 10.5 17.4 10.5C19.3882 10.5 21 12.1416 21 14.1667C21 16.1917 19.3882 17.8333 17.4 17.8333" stroke="#fff" strokeLinecap="round" strokeLinejoin="round"></path></g></svg>
                                    Download
                                </a>
                                <div className="txt-eg">{outputFileName}</div>
                            </div>
                            <br /><br />
                          
                        </div>

                    </div>

                </>
            ) : ''}

        </>
    )
}



export default AutoPanner
